import { render, staticRenderFns } from "./ChameleonForm.vue?vue&type=template&id=d52c0f98&scoped=true&lang=pug&"
import script from "./ChameleonForm.vue?vue&type=script&lang=js&"
export * from "./ChameleonForm.vue?vue&type=script&lang=js&"
import style0 from "./ChameleonForm.vue?vue&type=style&index=0&id=d52c0f98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52c0f98",
  null
  
)

export default component.exports